export default __webpack_public_path__ + "static/media/img-cwa-user-experience-03.95f49c4e.png";